import React from 'react';
import {Product} from "../../components/item/Product";
import {SectionHeader} from "../../components/section-header/SectionHeader";
import { ItemGroup } from "../../components/item-group/ItemGroup";
import {ComponentFrame} from "../../frame/ComponentFrame";
import { ButtonGroup } from "../../components/button/ButtonGroup";
import { Container } from 'reactstrap';
import {GridLayout} from "../../components/layout/GridLayout";
import { history } from "../../redux/store";
import {BasicAnimation} from "../../components/animations/BasicAnimation";

export class ProductList extends React.Component {

  constructor(props) {
    super(props);

    this.changeFilter = this.changeFilter.bind(this);
    this.init = this.init.bind(this);

    this.init(this.props, object => this.state = object );
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.solution_categories || nextProps.solution_products)
      this.init(nextProps, object => this.setState(object));
  }

  init(props,func){
    let category = ( props.solution_categories.length > 0 && props.solution_categories[0].id ) || null;

    if(history.location.state &&
      history.location.state.category_id &&
      props.solution_categories.map( c => c.id).find( id => id === history.location.state.category_id)){

      category = history.location.state.category_id;
    }

    const selected_data = props.solution_products
      ? (
        category
          ? props
            .solution_products
            .filter(product =>  product.product_categories.indexOf(category) !== -1 )
          : props.solution_products )
      : null;

    func({
      selected_category: category,
      selected_data
    });
  }

  isSelected(a,b){
    return a === b;
  }

  changeFilter(category){
    this.setState({
      selected_category: category.id,
      selected_data: this.props.solution_products.filter(product => product.product_categories.indexOf(category.id) !== -1)
    });

    if( history && history.replace ){

      history.replace(
        history.location.pathname + ( history.location.search ? '?' + history.location.search : '' ),
        {
          category_id: category.id,
          noscroll: true
        }
      );

    }
  }

  render(){
    return (
      <div className="product-list-container">

        <BasicAnimation duration={800} delay={0}>
        <ComponentFrame header={
                          <SectionHeader align="center"
                                         color="transparent"
                                         title="Products" />
                        }>
          <Container className="p-0">
            <ButtonGroup data={this.props.solution_categories}
                         selected_button={this.state.selected_category}
                         isSelected={this.isSelected}
                         selected={this.changeFilter}/>
          </Container>
          <ItemGroup layout={ GridLayout } item={ Product }
                     itemStyle="floating-card" data={this.state.selected_data}/>
        </ComponentFrame>
        </BasicAnimation>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/views/products/ProductList.js